import {BaseDTO} from '../../common/models/BaseDTO';

export class ManufacturerDTO extends BaseDTO {
  manufacturerId: number;
  name: string;
}
